import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;
  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  GetAllFilesByCurrentUser(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.Dashboard.GetAllFilesByCurrentUser, val);
  }

  GetFileStatistics() {
    return this.http.get(this.apiUrl + ApiUrls.Dashboard_Analytics.FileStatistics);
  }
  GetFileCountByUserList(val: any) {
    return this.http.post(this.apiUrl + ApiUrls.Dashboard_Analytics.FileCountByUser, val);
  }
  TopMaxQuestionsWithStatus(count: string) {
    const query = new HttpParams().set('count', count);
    return this.http.get(this.apiUrl + ApiUrls.Dashboard_Analytics.TopMaxQuestionsWithStatus, { params: query });
  }
}
